import { TyOption, TySelectInput } from '@tymbe/ui-forms';
import { FavouriteIcon } from '@tymbe/ui-icons';
import Spinner from '@tymbe/ty-components/indicators/Spinner';
import { useState, useEffect } from 'react';
import { useFormApi } from 'informed';
import { CompanyDefaultSettingsFormData } from './CompanyShiftDefaultSettings';
import styles from '../../../components/TyAdvancedSearch/Components/Layout.module.css';
import { ContestDuration } from '@tymbe/schema/enums';

type Props = {
  isLoading: boolean;
  setShowModal: (show: boolean) => void;
  initialData?: CompanyDefaultSettingsFormData;
};

const validateContestEndTime = (value: string | undefined, contestEndVariantValue: ContestDuration | undefined) => {
  if (contestEndVariantValue && !value) {
    return 'Čas konce zveřejnění je povinný';
  }
  return undefined;
};

const CompanyShiftDefaultSettingsForm = ({ isLoading, setShowModal, initialData }: Props) => {
  const [contestEndVariant, setContestEndVariant] = useState<ContestDuration | undefined>(undefined);
  const { setValue, getValue } = useFormApi<CompanyDefaultSettingsFormData>();

  useEffect(() => {
    if (initialData?.shift_contest_end_variant && !contestEndVariant) {
      setContestEndVariant(initialData.shift_contest_end_variant);
    }
  }, [initialData]);

  return (
    <>
      <div className="p-5 flex flex-row justify-between">
        <div className="flex flex-col flex-grow">
          <div className="flex flex-row gap-5">
            <TySelectInput<ContestDuration>
              name="shift_contest_end_variant"
              label="Zveřejnění směny do"
              optionsPosition="top"
              onChange={(value) => {
                setContestEndVariant(value?.value);
              }}
              onReset={() => {
                setContestEndVariant(undefined);
              }}
            >
              <TyOption value={ContestDuration.DAY_OF_SHIFT_BEFORE_AT} label="V den nástupu v">
                V den nástupu v
              </TyOption>
              <TyOption value={ContestDuration.DAY_BEFORE_AT} label="Den před nástupem v">
                Den před nástupem v
              </TyOption>
              <TyOption value={ContestDuration.WORKDAY_BEFORE_AT} label="Pracovní den (včetně svátků) před nástupem v">
                Pracovní den (včetně svátků) před nástupem v
              </TyOption>
              <TyOption value={ContestDuration.NON_HOLIDAY_WORKDAY_BEFORE_AT} label="Pracovní den (mimo svátky) před nástupem v">
                Pracovní den (mimo svátky) před nástupem v
              </TyOption>
            </TySelectInput>
            {getValue('shift_contest_end_variant') !== undefined ? (
              <div
                className="absolute right-7 top-8 cursor-pointer z-10"
                onClick={() => {
                  setValue('shift_contest_end_variant', undefined);
                  setContestEndVariant(undefined);
                }}
              >
                <FavouriteIcon name="close" className="size-4" />
              </div>
            ) : null}
            <TySelectInput<string | undefined>
              disabled={!contestEndVariant}
              name="shift_contest_end_time"
              optionsPosition="top"
              className="mt-4"
              validate={(value) => validateContestEndTime(value, contestEndVariant)}
            >
              {Array.from({ length: 48 }, (_, i) => {
                const hours = Math.floor(i / 2);
                const minutes = (i % 2) * 30;
                const timeString = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
                return (
                  <TyOption key={timeString} value={timeString} label={timeString}>
                    {timeString}
                  </TyOption>
                );
              })}
            </TySelectInput>
          </div>
        </div>
      </div>
      <div className="bg-[#F3F5FD] py-8 px-4 flex justify-end">
        <div className={styles.footerRight}>
          <button type="button" className="ty-button-secondary " onClick={() => setShowModal(false)}>
            Zavřít
          </button>
          <button
            type="submit"
            className="ty-button-primary transition-transform duration-500 disabled:cursor-not-allowed disabled:opacity-70"
            disabled={isLoading}
          >
            {!isLoading ? (
              'Uložit'
            ) : (
              <>
                <span> Ukládám... </span> <Spinner show className="ml-6 w-6" />{' '}
              </>
            )}
          </button>
        </div>
      </div>
    </>
  );
};

export default CompanyShiftDefaultSettingsForm;
